"use strict";
// packages/shared-react/src/hooks/useDeleteConversation.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAgentApiDeleteConversation = useAgentApiDeleteConversation;
const recoil_1 = require("recoil");
const shared_1 = require("@heartcheck/shared");
const state_1 = require("../state");
const deleteConversationQuery = new shared_1.GraphqlQuery(
/* GraphQL */ `
    mutation DeleteConversation($id: ID!) {
      deleteConversation(id: $id) {
        id
      }
    }
  `, 
// ✅ Use Cognito User Pools (ID token) via your /graphql proxy
{ forwardAuthMode: "userpools" });
function useAgentApiDeleteConversation() {
    const setConversationsValue = (0, recoil_1.useSetRecoilState)(state_1.Conversations);
    return async (id) => {
        if (!id || typeof id !== "string") {
            // eslint-disable-next-line no-console
            console.error("❌ No valid conversation ID provided for deletion.");
            return;
        }
        try {
            const raw = await deleteConversationQuery.invoke({ id });
            const res = raw;
            if (!res?.deleteConversation?.id) {
                throw new Error("Delete mutation did not return an ID.");
            }
            // Force a refresh by marking the state as unloaded.
            setConversationsValue(state_1.Loadable.unloaded());
            // eslint-disable-next-line no-console
            console.log(`✅ Conversation deleted: ${res.deleteConversation.id}`);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error("❌ Failed to delete conversation:", err);
            // Keep state as-is, UI decides how to show failure.
        }
    };
}
